import { useEffect, useMemo } from 'react';

import { throttleRaf } from '../utils/throttleRaf.js';

export const useThrottledCallbackOnScroll = (
  disabled: boolean,
  callback: (event: Event) => void,
): void => {
  const throttledCallback = useMemo(
    () => throttleRaf(callback),
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    if (disabled) {
      return;
    }

    document.body.addEventListener('scroll', throttledCallback, true);
    return () => {
      document.body.removeEventListener('scroll', throttledCallback, true);
    };
  }, [disabled, throttledCallback]);
};
